import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard {

  constructor(private authService: AuthService, private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.authService.isLoggedIn()) {
      //console.log('Not authorized')
      this.router.navigate(['login']);
      return false;
    }

    const roleRequested = route.data['role'] as Array<string>;
    const currentRole = this.authService.getRole();
    // console.log("Role requested: " + roleRequested);
    // console.log("Current Role: " + currentRole);
    if (this.authService.isLoggedIn()) {
      for (let i = 0; i < roleRequested.length; i++) {
        if (currentRole == roleRequested[i]) {
          return true
        }
      }
    }

    // if (roleRequested != currentRole)
    //   return false;

    // logged in, so return true
    this.authService.isLoggedIn();
    return true;
  }

}
